module.exports = __webpack_public_path__ + "media/images/arrow-right-85dda39a9b250168d039232aed6ba516.svg";